// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"zP-z","inlineTitle":"AP-z","sponsoredAdsWrapper":"BP-z","marketplaceRecosWrapper":"CP-z"};